import {type CSSProperties} from 'react'
import {useGetRootSize} from './useGetRootSize'
import {getWidthSize, getOrderWidthSize} from '../lib/getWidthSize'
import {getHeightSize, getOrderHeightSize} from '../lib/getHeightSize'

type Axis = 'height' | 'width'
type Axises = Record<Axis, number>

type UsedCssProperties = 'height' | 'width' | 'fontSize' | 'rowGap'
  | 'margin' | 'marginTop' | 'marginBottom' | 'marginLeft' | 'marginRight'
  | 'padding' | 'paddingTop' | 'paddingBottom' | 'paddingLeft' | 'paddingRight'

export type PropertyAdaptiveStyle = {
  cssKey: keyof Pick<CSSProperties, UsedCssProperties>
  params: [number, number, number, number, number, number, number]
  axis: Axis,
  onlyMobile?: boolean
  onlyDesktop?: boolean
}

export type PropsAdaptiveStyle = Array<PropertyAdaptiveStyle>

export const useGetAdaptiveStyle = (props: PropsAdaptiveStyle) => {
  const {height = 0, width = 0} = useGetRootSize()

  const widthSize = getWidthSize(width)
  const heightSize = getHeightSize(height)
  const axises: Axises = {
    height: getOrderHeightSize(height),
    width: getOrderWidthSize(width)
  }
  const isMobile = ['sm', 'xs', 'xxs'].includes(widthSize)
  const isTooSmallScreen = heightSize === 'xxs'

  const style: CSSProperties = props.reduce<CSSProperties>((acc, item) => {
    if (item.onlyMobile && !isMobile) return acc
    if (item.onlyDesktop && isMobile) return acc
    acc[item.cssKey] = item.params[axises[item.axis]]
    return acc
  }, {})

  const styleHideWhenTooSmallScreen: CSSProperties = {}
  if (isTooSmallScreen) {
    styleHideWhenTooSmallScreen.height = 0
    styleHideWhenTooSmallScreen.visibility = 'hidden'
  }
  return {
    width,
    height,
    widthSize,
    heightSize,
    isMobile,
    isTooSmallScreen,
    style,
    styleHideWhenTooSmallScreen,
  }
}
